import React from 'react';
import { Button, DropdownSelector, FormError, NumberInput, Toggle, useErrorScroll, useForm } from 'library';
import { getAllStatesForDropdown } from 'utils/states';

import { INVESTMENT_BUCKET_OPTIONS } from '../../fitQuiz/utils/fitQuizDataUtils';
import {
  CREDIT_SCORE_OPTIONS,
  FORECLOSURE_BANKRUPTCY_OPTIONS,
  PROPERTY_TYPE_OPTIONS,
  PROPERTY_USE_OPTIONS,
} from '../utils/ppqDataUtils';

const PPQForm = ({ onSubmit }) => {
  const { registerField, handleSubmit, handleFieldChange, formSubmitError } = useForm({
    foreclosure: 'no',
    bankruptcy: 'no',
  });
  useErrorScroll(formSubmitError);

  const states = getAllStatesForDropdown();

  const investmentOptions = INVESTMENT_BUCKET_OPTIONS.map((bucket) => {
    return { label: bucket, value: bucket };
  });

  const creditScoreOptions = CREDIT_SCORE_OPTIONS.map((score) => {
    return { label: score, value: score };
  });

  const handleFormatOnSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <div className="PPQForm">
      <FormError standalone error={formSubmitError} />
      <form onSubmit={handleSubmit(handleFormatOnSubmit)}>
        <DropdownSelector
          label="1. In which state is the property located?"
          options={states}
          required
          {...registerField('state')}
        />
        <DropdownSelector
          label="2. What is the ideal amount for a Hometap Investment?"
          options={investmentOptions}
          required
          {...registerField('ideal_investment_amount')}
        />
        <DropdownSelector
          label="3. What is the homeowner’s credit score?"
          options={creditScoreOptions}
          required
          {...registerField('credit_score')}
        />
        <DropdownSelector
          label="4. What is the property type?"
          options={PROPERTY_TYPE_OPTIONS}
          required
          {...registerField('property_type')}
        />
        <DropdownSelector
          label="5. How is the property being used?"
          options={PROPERTY_USE_OPTIONS}
          required
          {...registerField('property_usage')}
        />
        <NumberInput
          label={
            <span>
              6. What is the estimated home value?{' '}
              <span className="quiz-personal-form--smalltext">Estimate to the nearest $1,000</span>
            </span>
          }
          required={true}
          type="currency"
          placeholder="$"
          precision={0}
          {...registerField('home_value')}
          onBlur={(value) => {
            if (value) {
              setTimeout(() => {
                handleFieldChange(Math.round(value / 1000) * 1000, 'home_value');
              }, 0);
            }
          }}
        />
        <NumberInput
          label={
            <span>
              7. What is the estimated mortgage balance?{' '}
              <span className="quiz-personal-form--smalltext">Estimate to the nearest $1,000</span>
            </span>
          }
          required={true}
          type="currency"
          placeholder="$"
          precision={0}
          {...registerField('mortgage_balance')}
          onBlur={(value) => {
            if (value) {
              setTimeout(() => {
                handleFieldChange(Math.round(value / 1000) * 1000, 'mortgage_balance');
              }, 0);
            }
          }}
        />
        <NumberInput
          label="8. In the last 12 months, how many mortgage payments were late?"
          required={true}
          type="integer"
          placeholder="Enter a number"
          {...registerField('num_late_payments')}
        />
        <Toggle
          label="9. In the last 5 years, has the homeowner experienced foreclosure?"
          options={FORECLOSURE_BANKRUPTCY_OPTIONS}
          name="foreclosure"
          {...registerField('foreclosure')}
        />
        <Toggle
          label="10. In the last 5 years, has the homeowner experienced bankruptcy?"
          options={FORECLOSURE_BANKRUPTCY_OPTIONS}
          name="bankruptcy"
          {...registerField('bankruptcy')}
        />
        <div style={{ textAlign: 'center' }} className="PPQFormButton">
          <Button type="submit">Find out if Hometap is a fit</Button>
        </div>
      </form>
    </div>
  );
};

export default PPQForm;
